export default "//yastatic.net/s3/distribution/pythia/frontend/_/412349da94a6d6617a57e9ae0908cf21.svg";